var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 38,
    viewBox: "0 0 101 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28 29V0.999998H12.04L23.24 19.28H19.16L30.04 0.999998H37.8L37.88 29H29.28L29.2 13.96H30.56L23.12 26.48H18.96L11.2 13.96H12.88V29H4.28ZM52.8841 29.64C50.5374 29.64 48.2707 29.3733 46.0841 28.84C43.8974 28.3067 42.0974 27.6133 40.6841 26.76L43.7241 19.88C45.0574 20.6533 46.5374 21.28 48.1641 21.76C49.8174 22.2133 51.4174 22.44 52.9641 22.44C53.8707 22.44 54.5774 22.3867 55.0841 22.28C55.6174 22.1467 56.0041 21.9733 56.2441 21.76C56.4841 21.52 56.6041 21.24 56.6041 20.92C56.6041 20.4133 56.3241 20.0133 55.7641 19.72C55.2041 19.4267 54.4574 19.1867 53.5241 19C52.6174 18.7867 51.6174 18.5733 50.5241 18.36C49.4307 18.12 48.3241 17.8133 47.2041 17.44C46.1107 17.0667 45.0974 16.5733 44.1641 15.96C43.2574 15.3467 42.5241 14.5467 41.9641 13.56C41.4041 12.5467 41.1241 11.2933 41.1241 9.8C41.1241 8.06667 41.6041 6.49333 42.5641 5.08C43.5507 3.64 45.0041 2.49333 46.9241 1.64C48.8707 0.786666 51.2841 0.359999 54.1641 0.359999C56.0574 0.359999 57.9241 0.559999 59.7641 0.959999C61.6041 1.36 63.2574 1.97333 64.7241 2.8L61.8841 9.64C60.4974 8.94666 59.1507 8.42667 57.8441 8.08C56.5641 7.73333 55.3107 7.56 54.0841 7.56C53.1774 7.56 52.4574 7.64 51.9241 7.8C51.3907 7.96 51.0041 8.17333 50.7641 8.44C50.5507 8.70667 50.4441 9 50.4441 9.32C50.4441 9.8 50.7241 10.1867 51.2841 10.48C51.8441 10.7467 52.5774 10.9733 53.4841 11.16C54.4174 11.3467 55.4307 11.5467 56.5241 11.76C57.6441 11.9733 58.7507 12.2667 59.8441 12.64C60.9374 13.0133 61.9374 13.5067 62.8441 14.12C63.7774 14.7333 64.5241 15.5333 65.0841 16.52C65.6441 17.5067 65.9241 18.7333 65.9241 20.2C65.9241 21.9067 65.4307 23.48 64.4441 24.92C63.4841 26.3333 62.0441 27.48 60.1241 28.36C58.2041 29.2133 55.7907 29.64 52.8841 29.64ZM68.7331 29V0.999998H76.4931L90.7331 18.04H87.1331V0.999998H96.3331V29H88.5731L74.3331 11.96H77.9331V29H68.7331Z",
    fill: "url(#paint0_linear_11_155)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_155",
    x: 0.280029,
    y: 0.359985,
    width: 100.053,
    height: 37.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_155",
    x1: 2,
    y1: -6.73333,
    x2: 88.7304,
    y2: 11.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89337"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsn);
export default __webpack_public_path__ + "static/media/MSN.130d82ed1abb941cae393d5709ae5cf0.svg";
export { ForwardRef as ReactComponent };